import { ClienteService } from '../../services/cliente.service';
import { Router } from '@angular/router';
var EditarClienteComponent = /** @class */ (function () {
    function EditarClienteComponent(clienteService, router) {
        this.clienteService = clienteService;
        this.router = router;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = new Array();
        this.cliente = this.clienteService.getCliente();
        if (!this.cliente) {
            this.router.navigate(['dashboard/clientes']);
        }
    }
    EditarClienteComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
    };
    EditarClienteComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.clienteService.guardar(this.cliente)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar cliente";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Los datos se han actualizado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar cliente";
            _this.alert.mensaje = "Los datos se han actualizado correctamente";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    EditarClienteComponent.prototype.volver = function () {
        this.router.navigate(['dashboard/clientes']);
    };
    EditarClienteComponent.ctorParameters = function () { return [{ type: ClienteService }, { type: Router }]; };
    return EditarClienteComponent;
}());
export { EditarClienteComponent };
//# sourceMappingURL=editar-cliente.component.js.map


// WEBPACK FOOTER //
// editar-cliente.component.js